module.exports = __webpack_public_path__ + "static/media/mind-share.8e02fc3c.svg";